import type { MediaFile } from "../apiTypes";
import type {
  AnomalyApi,
  ApiV1AnomalyAnomalyIdPatchRequest,
} from "../generated";
import { createAPISlice } from "./createAPISlice";

export default function createAnomalyApis(anomalyApi: AnomalyApi) {
  return createAPISlice({
    deleteAnomaly: async (anomalyApiId: string) => {
      return await anomalyApi.apiV1AnomalyAnomalyIdDelete(anomalyApiId);
    },
    updateAnomaly: async (
      anomalyApiId: string,
      data: ApiV1AnomalyAnomalyIdPatchRequest,
      abortController?: AbortController,
    ) => {
      return await anomalyApi.apiV1AnomalyAnomalyIdPatch(anomalyApiId, data, {
        signal: abortController?.signal,
      });
    },
    addPhoto: async ({
      anomalyApiId,
      photoFile,
    }: {
      anomalyApiId: string;
      photoFile: MediaFile;
    }) => {
      return await anomalyApi.apiV1AnomalyAnomalyIdPhotoPost(
        anomalyApiId,
        // @ts-expect-error swagger generated code doesn't support File type, but it does work with it
        [photoFile],
        {
          transformRequest: (d: unknown) => d,
        },
      );
    },
    deletePhoto: async ({
      anomalyApiId,
      photoId,
    }: {
      anomalyApiId: string;
      photoId: string;
    }) => {
      return await anomalyApi.apiV1AnomalyAnomalyIdPhotoPhotoIdDelete(
        anomalyApiId,
        photoId,
      );
    },
  });
}
